function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react'; // original author: will

import PropTypes from 'prop-types';
import gettext from 'js-utils/gettext';
import classNames from 'classnames';
import Icon from '../icon/Icon';
import Button from '../button/Button';
import IconButton from '../iconButton/IconButton';
import { ICON_TYPE_PROP_TYPE } from '../icon/constants';
import { STYLE_INVERSE, STYLE_DARK } from '../iconButton/constants';
import { STYLE_ANCHOR as BTN_STYLE_ANCHOR, STYLE_INVERSE as BTN_STYLE_INVERSE } from '../button/constants';
import * as constants from './constants';
import { getAdditionalProps } from '../utils/propTypes';
import CrossChunkySvg from '../iconography/icons/CrossChunky';

var NotificationBarIcon = function NotificationBarIcon(_ref) {
  var shouldShow = _ref.shouldShow,
      iconType = _ref.iconType,
      iconColor = _ref.iconColor;
  var component = null;

  if (shouldShow && iconType) {
    component = React.createElement("div", {
      className: "eds-notification-bar__icon"
    }, React.createElement(Icon, {
      type: iconType,
      color: iconColor,
      "data-spec": "notification-bar-icon"
    }));
  }

  return component;
};

var NotificationBarClose = function NotificationBarClose(_ref2) {
  var shouldShow = _ref2.shouldShow,
      onClick = _ref2.onClick,
      useInverseStyle = _ref2.useInverseStyle,
      iconColor = _ref2.iconColor;
  var component = null;
  var style = useInverseStyle ? STYLE_INVERSE : STYLE_DARK;

  if (shouldShow) {
    component = React.createElement("div", {
      className: "eds-notification-bar__close eds-l-pad-right-2 eds-l-pad-vert-1"
    }, React.createElement(IconButton, {
      iconType: React.createElement(CrossChunkySvg, null),
      "data-spec": "close-button",
      title: gettext('Close'),
      style: style,
      onClick: onClick,
      iconColor: iconColor
    }));
  }

  return component;
};

var NotificationBarCTA = function NotificationBarCTA(_ref3) {
  var isOrbital = _ref3.isOrbital,
      callAction = _ref3.callAction,
      onClick = _ref3.onClick;
  var component = null;

  if (callAction && onClick) {
    var buttonStyle = isOrbital ? BTN_STYLE_INVERSE : BTN_STYLE_ANCHOR;
    component = React.createElement("div", {
      className: "eds-notification-bar__cta",
      "data-spec": "notification-bar-cta"
    }, React.createElement(Button, {
      style: buttonStyle,
      onClick: onClick,
      "data-spec": "notification-bar-cta-btn"
    }, callAction));
  }

  return component;
};

var NotificationBar =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(NotificationBar, _React$PureComponent);

  function NotificationBar(props) {
    var _this;

    _classCallCheck(this, NotificationBar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NotificationBar).call(this, props));
    var isHidden = props.isHidden;
    _this.state = {
      isHidden: isHidden
    };
    return _this;
  }

  _createClass(NotificationBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _notificationElement = this._notificationElement;
      var shouldScrollTo = this.props.shouldScrollTo;
      var isHidden = this.state.isHidden;

      if (!isHidden && _notificationElement && shouldScrollTo) {
        this._scrollIntoView(_notificationElement);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref4) {
      var isHidden = _ref4.isHidden;
      this.setState({
        isHidden: isHidden
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _notificationElement = this._notificationElement;
      var shouldScrollTo = this.props.shouldScrollTo;
      var isHidden = this.state.isHidden;

      if (!isHidden && _notificationElement && shouldScrollTo) {
        this._scrollIntoView(_notificationElement);
      }
    }
  }, {
    key: "_handleCloseClick",
    value: function _handleCloseClick() {
      this.setState({
        isHidden: true
      });

      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  }, {
    key: "_setNotificationRef",
    value: function _setNotificationRef(element) {
      this._notificationElement = element;
    }
  }, {
    key: "_scrollIntoView",
    value: function _scrollIntoView(element) {
      if (element && element.scrollIntoView) {
        element.scrollIntoView();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.isHidden) {
        return null;
      }

      var _this$props = this.props,
          iconType = _this$props.iconType,
          children = _this$props.children,
          hasCloseButton = _this$props.hasCloseButton,
          type = _this$props.type,
          __containerClassName = _this$props.__containerClassName,
          callAction = _this$props.callAction,
          callActionString = _this$props.callActionString,
          onCallAction = _this$props.onCallAction,
          callActionClick = _this$props.callActionClick;
      var extraAttrs = getAdditionalProps(this);
      var isOrbital = type === constants.TYPE_ORBITAL;
      var isDefault = type === constants.TYPE_NEUTRAL;
      var isSuccess = type === constants.TYPE_SUCCESS;
      var className = classNames({
        'eds-notification-bar--has-close': hasCloseButton
      }, 'eds-notification-bar', "eds-notification-bar--".concat(type), __containerClassName);

      var storeRef = this._setNotificationRef.bind(this);

      var iconColor = isDefault ? constants.ICON_COLOR : constants.ICON_INVERSE_COLOR;
      var showIcon = !isOrbital;
      var showClose = hasCloseButton || isOrbital;
      return React.createElement("div", _extends({}, extraAttrs, {
        className: className,
        role: "alert",
        "data-spec": "notification-bar",
        ref: storeRef
      }), React.createElement(NotificationBarIcon, {
        shouldShow: showIcon,
        iconType: iconType,
        iconColor: iconColor
      }), React.createElement("div", {
        className: "eds-notification-bar__content"
      }, children), React.createElement(NotificationBarCTA, {
        isOrbital: isOrbital,
        callAction: callAction || callActionString,
        onClick: onCallAction || callActionClick
      }), React.createElement(NotificationBarClose, {
        shouldShow: showClose,
        onClick: this._handleCloseClick.bind(this),
        useInverseStyle: !isDefault && !isSuccess,
        iconColor: iconColor
      }));
    }
  }]);

  return NotificationBar;
}(React.PureComponent);

_defineProperty(NotificationBar, "propTypes", {
  /**
   * Icon to show on the left of the notification bar
   */
  iconType: ICON_TYPE_PROP_TYPE,

  /**
   * Usually plain text or a node with notification text
   */
  children: PropTypes.node.isRequired,

  /**
   * Type of notification
   */
  type: constants.NOTIFICATION_TYPES_PROP_TYPE,

  /**
   * Show/hide close button
   */
  hasCloseButton: PropTypes.bool,

  /**
   * CTA for notification
   */
  callAction: PropTypes.node,
  // DEPRECATED
  callActionString: PropTypes.node,

  /**
   * CTA callback for notification
   */
  onCallAction: PropTypes.func,
  // DEPRECATED
  callActionClick: PropTypes.func,

  /**
   * Callback method when close button has been clicked
   */
  onClose: PropTypes.func,

  /**
   * Hide notification
   */
  isHidden: PropTypes.bool,

  /**
   * Container class name
   */
  __containerClassName: PropTypes.string,

  /**
   * Should scroll to notification on render
   */
  shouldScrollTo: PropTypes.bool
});

_defineProperty(NotificationBar, "defaultProps", {
  type: constants.TYPE_NEUTRAL,
  isHidden: false,
  hasCloseButton: false,
  shouldScrollTo: false
});

export { NotificationBar as default };